import { render, staticRenderFns } from "./ScreenLaudoObstetricaPerfilCervical.vue?vue&type=template&id=11e994ea&lang=true&"
import script from "./ScreenLaudoObstetricaPerfilCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoObstetricaPerfilCervical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports